export default {
    questions: {},
    loading: false,
    error: null,
    errorShow: false
}